import { h } from 'preact';
import style from './style';
import cx from 'classnames';
import Icon from '../icon';

/**
 * Header
 */
export default function Header({ children, title, titleIcon, ...props }) {
	return (
		<header {...props} class={cx(style.header, props.class)}>
			<div class={style.title}>
				{ titleIcon && <Icon name={titleIcon} /> }
				{ title }
			</div>
			<div class={cx(style.right)}>{ children }</div>
		</header>
	);
}
